import axios from "axios"
import { LOGIN_USER_ERROR, LOGIN_USER_LOADING, LOGIN_USER_SUCCESS } from "./user_types"
import { BASE_URL } from "../../constants/config"

import {toast , Toaster } from 'react-hot-toast';

export const getUser = (obj) => async(dispatch) => {
    dispatch({type: LOGIN_USER_LOADING})
    try {
        let data = await axios(BASE_URL+"/user/login", {
                        method: "post",
                        data: obj
                })
        let {message, user, token, status} = data.data
        if(status === 1)
            return dispatch({type: LOGIN_USER_SUCCESS, payload: {user, token}})
        else
        {
            toast.error("Error en la conexión."+message);
            return dispatch({type: LOGIN_USER_ERROR})
        }

    } catch (error) {
        //alert(" Error en la conexión ")
        toast.error("Error en la conexión");
        return dispatch({type: LOGIN_USER_ERROR})
    }
}